
import appMarketInstance from './app-market-sdk';

let AppMarket;

if (typeof window === 'object') {
  AppMarket = appMarketInstance();
}

/**
 * Wrapped App Market SDK
 * It will not fail when it's not available
 * It's done hard way to have good code auto complete
 */

export const getIfAppIsInstalled = (options, callback) => exec('getIfAppIsInstalled', [options, callback]);
export const addAppToSite = (options) => exec('addAppToSite', [options]);
export const addComponentToSite = (compType, biData) => exec('addComponentToSite', [compType, biData]);
export const addPendingApp = (appId) => exec('addPendingApp', [appId]);
export const call = (cmd, params, onResponseCallback) => exec('call', [cmd, params, onResponseCallback]);
export const closeAppMarketModal = (id) => exec('closeAppMarketModal', [id]);
export const closeAppPopup = () => exec('closeAppPopup', []);
export const closeModal = (action) => exec('closeModal', [action]);
export const getPendingAppsList = (callback) => exec('getPendingAppsList', [callback]);
export const getUserDetails = (callback) => exec('getUserDetails', [callback]);
export const init = (onOpenCallback, callbackParams) => exec('init', [onOpenCallback, callbackParams]);
export const isDevMode = (callback) => exec('isDevMode', [callback]);
export const openApp = (appDefinitionId) => exec('openApp', [appDefinitionId]);
export const openAppInfoModal = (url, width, height, closeCallback) => exec('openAppInfoModal', [url, width, height, closeCallback]); // eslint-disable-line
export const openAppMarketModal = (url, width, height, id, options) => exec('openAppMarketModal', [url, width, height, id, options]); // eslint-disable-line
export const openPermissionsModal = (url, width, height, appDefinitionId) => exec('openPermissionsModal', [url, width, height, appDefinitionId]);
export const removePendingApp = (appId) => exec('removePendingApp', [appId]);
export const save = (onSuccess, onFailure) => exec('save', [onSuccess, onFailure]);
export const setAppMarketState = (state) => exec('setAppMarketState', [state]);
export const closeAppMarket = () => exec('closeAppMarket', []);
export const openAppMarketHelp = () => exec('openAppMarketHelp', []);
export const openDeletePopupMessage = (options) => exec('openDeletePopupMessage', [options]);

export const getIfAppIsInstalledPromise = (options) => promisify('getIfAppIsInstalled', [options]);
export const getUserDetailsPromise = () => promisify('getUserDetails', []);


function promisify(fx, args) {
  if (!isAppMarket()) {
    return Promise.reject();
  }

  return new Promise((resolve, reject) => {
    const timeout = setTimeout(() => {
      reject(new Error('AppMarket SKD timeout'));
    }, 1000);

    args.push((...resp) => {
      resolve.apply(null, resp);
      clearTimeout(timeout);
    });

    AppMarket[fx].apply(AppMarket, args);
  });
}

function exec(fx, args) {
  if (isAppMarket()) {
    return AppMarket[fx].apply(AppMarket, args);
  }
}

function isAppMarket() {
  return typeof window === 'object' && typeof AppMarket === 'object';
}



// WEBPACK FOOTER //
// ./services/wrapped-app-market-sdk.js